// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2MWRk","fileDisabled":"File_fileDisabled__2PPRy"};